import './Offline.sass';

import React, { FC, useEffect } from 'react';
import { Placeholder, Button, LottieIcon } from '$uikit';
import { useDispatch } from 'react-redux';
import { mainActions } from '$store/main';
import { useTranslator } from '$hooks';

import('$assets/lottie/sad.json'); // For offline cache.

export const Offline: FC = () => {
  const dispatch = useDispatch();
  const t = useTranslator();
  useEffect(() => {
    dispatch(mainActions.checkConnection());
  }, []);

  return (
    <div className="Offline">
      <Placeholder
        centered
        iconSize={128}
        icon={<LottieIcon name="sad" />}
        title="No internet connection"
      >
        Please, check your internet connection
      </Placeholder>
    </div>
  );
};
